module.exports = __webpack_public_path__ + "static/media/splash.623c3b41.jpg";